// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__1K8lM","title":"styles_title__2ZNKh","subtitle":"styles_subtitle__1WGm3","btn":"styles_btn__1MWV1","mobileBtn":"styles_mobileBtn__3CBxo"};